import React, { useEffect, useState, useCallback }  from 'react';
import { motion } from "framer-motion";

import NoDataFound from "../../../../../ui/NoDataFound";
import SkeletonLoader from "../../../../../ui/SkeletonLoader";

import { useScanInfoContext } from "../../../../../../pages/ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getBecStats } from "../../../../../../store/actions/thirdPartyRiskAction";

const BusinessEmailCompromise = () => {

    const becStatsResponse = useSelector((state) => state.thirdPartyRisk.becStats);
            
    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const dispatch = useDispatch();

    const [becStatsLoading, setbecStatsLoading] = useState(false);

    const fetchbecStats = useCallback(()=>{
        setbecStatsLoading(true)
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`;
        dispatch(getBecStats(params))
    },[dispatch, organizationId, domainId, scanId])

    useEffect(()=>{
        if (triggerStatsFetch) {
            fetchbecStats();
            setTriggerStatsFetch(false);
        }
    },[triggerStatsFetch, setTriggerStatsFetch, fetchbecStats])

    useEffect(()=>{
        if(becStatsResponse !== null) {
            setbecStatsLoading(false);
        }
    },[becStatsResponse])

    return (
        <div className="bg-white-with-shadow p-4 h-100">
            {
                becStatsLoading ?
                <SkeletonLoader type={"line"} count={4} />
                :
                <motion.div
                    className="h-100"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <div className="d-flex justify-content-between mb-2 dashboard-box-container">
                        <p className="heading font-bold">Business Email Compromise (BEC)</p>
                    </div>
                    {
                        becStatsResponse?.status === "failed" || becStatsResponse === "Not Found" ?
                            <NoDataFound noDataText={becStatsResponse?.description} />
                        :
                        <div className="Business-container rounded p-1 mt-4">
                            <div className={`${becStatsResponse?.stats?.dmarc?.passed > 50 ? "box-green" : "box-orange"} rounded p-4 mb-2`}>
                                <p className="dmarc">DMARC</p>
                                <h4 className='mt-3'>{becStatsResponse?.stats?.dmarc?.passed || 0}% Passed</h4>
                                <p className='domain'>Domain-based Message <br />Authentication</p>
                            </div>
                            <div className={`${becStatsResponse?.stats?.dkim?.passed > 50 ? "box-green" : "box-orange"} rounded p-4 mb-2`}>
                                <p className="dmarc">DKIM</p>
                                <h4 className='mt-3'>{becStatsResponse?.stats?.dkim?.passed || 0}% Passed</h4>
                                <p className='domain'>DomainKeys Indentified Mail</p>
                            </div>
                            <div className={`${becStatsResponse?.stats?.bimi?.passed > 50 ? "box-green" : "box-orange"} rounded p-4 mb-2`}>
                                <p className="spf">BIMI</p>
                                <h4 className='mt-3'>{becStatsResponse?.stats?.bimi?.passed || 0}% Passed</h4>
                                <p className='sender'>Brand Indicators For <br /> Message Indentification</p>
                            </div>
                            <div className={`${becStatsResponse?.stats?.spf?.passed > 50 ? "box-green" : "box-orange"} rounded p-4 mb-2`}>
                                <p className="spf">SPF</p>
                                <h4 className='mt-3'>{becStatsResponse?.stats?.spf?.passed || 0}% Passed</h4>
                                <p className='sender'>Sender Policy Framework</p>
                            </div>
                        </div>
                    }                    
                </motion.div>
            }
        </div>
    )
}

export default BusinessEmailCompromise;